import { RefObject, useEffect } from "react";

export default function useClickOutsideClick<
  T extends HTMLElement = HTMLElement,
>(ref: RefObject<T>, func: () => void): [RefObject<T>] {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event?.target as Node)) {
        func();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  return [ref];
}
